import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { widgetShopApi } from '@entities/widget-shop/api';
import { TPaymentMethodType, TWidgetPlan } from '@entities/widget-shop/model/types';
import { handleErrorInsideQuery } from '@shared/helpers';
import { IDataResponseError } from '@shared/model/types/dataResponse.inteface';

export const usePayWidgetByCardQuery = () => {
    const { t } = useTranslation();

    return useMutation({
        mutationFn: ({
            id,
            isRecurrent,
            notMyCompany,
            paymentMethodType,
        }: {
            id: TWidgetPlan['id'];
            isRecurrent: boolean;
            notMyCompany: boolean;
            paymentMethodType: Exclude<TPaymentMethodType, 'invoice'>;
        }) => {
            const formData = new FormData();
            formData.append('is_recurrent', isRecurrent ? '1' : '0');
            formData.append('type', paymentMethodType);
            formData.append('not_my_company', notMyCompany ? '1' : '0');
            return widgetShopApi.payWidgetByCard({ formData, widgetPlanId: id });
        },
        onError: (error: AxiosError<IDataResponseError>) => {
            handleErrorInsideQuery(error, t('button.got_it.text'));
        },
    });
};
